import { render } from "./GiftHeader.vue?vue&type=template&id=4177adb2&scoped=true"
import script from "./GiftHeader.vue?vue&type=script&lang=js"
export * from "./GiftHeader.vue?vue&type=script&lang=js"

import "./GiftHeader.vue?vue&type=style&index=0&id=4177adb2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4177adb2"]])

export default __exports__